// @flow

import { makeApiCall } from '../apiService/apiService';
import { checkIfClient } from '../../services/helpers';
import { toastr } from 'react-redux-toastr';

export const pincodeServiceActions = {
  CHECK_PINCODE_SERVICEABILITY: 'CHECK_PINCODE_SERVICEABILITY',
  GET_LOCALITIES: 'GET_LOCALITIES',
  GET_EDD: 'GET_EDD',
  CHECK_PINCODE_SERVICEABILITY_INTERNAL:
    'CHECK_PINCODE_SERVICEABILITY_INTERNAL',
  GET_FROM_TO_PAIR_DETAILS: 'GET_FROM_TO_PAIR_DETAILS',
  DOWNLOAD: 'DOWNLOAD',
  GET_CLIENT: 'GET_CLIENTS'
};

export const checkPincodeServiceabilityAction = (load: Object) => ({
  type: pincodeServiceActions.CHECK_PINCODE_SERVICEABILITY,
  payload: load
});

export const getLocalitiesByPincodeAction = (load: Object) => ({
  type: pincodeServiceActions.GET_LOCALITIES,
  payload: load
});

export const getEstimatedDeliveryDateAction = (load: Object) => ({
  type: pincodeServiceActions.GET_EDD,
  payload: load
});

export const checkPincodeServiceabilityInternalAction = (load: Object) => ({
  type: pincodeServiceActions.CHECK_PINCODE_SERVICEABILITY_INTERNAL,
  payload: load
});

export const getFromToPairDetailsAction = (payload: Object) => ({
  type: pincodeServiceActions.GET_FROM_TO_PAIR_DETAILS,
  payload
});

export const getAllServiceablePincodesAction = (payload: Object) => ({
  type: pincodeServiceActions.DOWNLOAD,
  payload
});

export const getClientsList = (payload: Object) => ({
  type: pincodeServiceActions.GET_CLIENT,
  payload
});

export const getLocalitiesByPincode = (pincode: string, index: number) => (
  dispatch: Function
) => {
  dispatch(
    getLocalitiesByPincodeAction({
      fetchingLocalities: true,
      fetchedLocalities: [],
      pincodeIndex: index,
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getLocalityByPincode',
    replaceParamsArr: [{ key: 'pincode', val: pincode }],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getLocalitiesByPincodeAction({
            fetchingLocalities: false,
            pincodeIndex: index,
            fetchedLocalities: res.payload,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getLocalitiesByPincodeAction({
            fetchingLocalities: false,
            pincodeIndex: index,
            fetchedLocalities: [],
            error: res.errorMessage || 'Could not fetch localities'
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getLocalitiesByPincodeAction({
          fetchingLocalities: false,
          pincodeIndex: index,
          fetchedLocalities: [],
          error: res.errorMessage || 'Could not fetch localities'
        })
      );
    },
    catchCb: res => {
      dispatch(
        getLocalitiesByPincodeAction({
          fetchingLocalities: false,
          pincodeIndex: index,
          fetchedLocalities: [],
          error: (res && res.errorMessage) || 'Could not fetch localities'
        })
      );
    }
  };
  return makeApiCall(requestObj);
};

export const checkPincodeServiceability = (pincode: Object, index: number) => (
  dispatch: Function
) => {
  dispatch(
    checkPincodeServiceabilityAction({
      checking: true,
      pincodeIndex: index,
      pincodeData: null,
      checked: null,
      error: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pincodeDetails',
    pathVariables: [{ key: '{pincode}', val: pincode.code }],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('checkPincodeServiceability call ', res);

      if (res.status === 'SUCCESS') {
        dispatch(
          checkPincodeServiceabilityAction({
            checking: false,
            pincodeIndex: index,
            pincodeData: res.payload,
            checked: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          checkPincodeServiceabilityAction({
            checking: false,
            pincodeIndex: index,
            pincodeData: null,
            checked: true,
            error: res.errorMessage || 'Pincode not serviceable'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('checkPincodeServiceability call failed ', res);
      dispatch(
        checkPincodeServiceabilityAction({
          checking: false,
          pincodeIndex: index,
          pincodeData: null,
          checked: true,
          error: res.errorMessage || 'Could not check pincode serviceability '
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in checkPincodeServiceability call', res);
      dispatch(
        checkPincodeServiceabilityAction({
          checking: false,
          pincodeIndex: index,
          pincodeData: null,
          checked: true,
          error: 'Could not check pincode serviceability '
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getEstimatedDeliveryDate = (obj: Object) => (
  dispatch: Function
) => {
  dispatch(
    getEstimatedDeliveryDateAction({
      eddFetching: true,
      pincodeIndex: obj.index,
      eddFetched: null,
      edd: null
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'edd',
    replaceParamsArr: [
      {
        key: 'clientId',
        val: obj.clientId
      },
      {
        key: 'bookingDateTime',
        val: obj.bookingDateTime
      },
      {
        key: 'fromPinCode',
        val: obj.fromPinCode
      },
      {
        key: 'toPinCode',
        val: obj.toPinCode
      },
      {
        key: 'serviceType',
        val: obj.serviceType
      },
      {
        key: 'weight',
        val: obj.weight
      },
      {
        key: 'totalBoxes',
        val: obj.totalBoxes
      }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      console.log('getEstimatedDeliveryDate call ', res);

      if (res.status === 'SUCCESS') {
        dispatch(
          getEstimatedDeliveryDateAction({
            eddFetching: false,
            pincodeIndex: obj.pincodeIndex,
            edd: res.payload,
            eddFetched: true,
            error: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getEstimatedDeliveryDateAction({
            eddFetching: false,
            pincodeIndex: obj.pincodeIndex,
            edd: null,
            eddFetched: true,
            error: res.errorMessage || 'Could not get edd'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getEstimatedDeliveryDate call failed ', res);
      dispatch(
        getEstimatedDeliveryDateAction({
          eddFetching: false,
          pincodeIndex: obj.pincodeIndex,
          edd: null,
          eddFetched: true,
          error: res.errorMessage || 'Could not get edd'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getEstimatedDeliveryDate call', res);
      dispatch(
        getEstimatedDeliveryDateAction({
          eddFetching: false,
          pincodeIndex: obj.pincodeIndex,
          edd: null,
          eddFetched: true,
          error: 'Could not get edd '
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

const pincodeCallPostData = () => ({
  appName: 'zoom-web-app'
});

export const checkPincodeServiceabilityNew = (requestData: Object) => (
  dispatch: Function
) => {
  dispatch(
    checkPincodeServiceabilityInternalAction({
      checkingInternal: true,
      pincodeDataInternal: null,
      checkedInternal: null,
      errorInternal: null,
      pincodeIndex: requestData.index
    })
  );

  const params = requestData.clientCode
    ? { clientCode: requestData.clientCode }
    : null;

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: requestData.isExternal
      ? 'pincodeDetailsExternal'
      : 'pincodeDetailsInternal',
    method: 'POST',
    pathVariables: [
      { key: '{pincode}', val: requestData.pincode },
      { key: '{type}', val: requestData.type }
    ],
    params,
    data: pincodeCallPostData(),
    successCb: res => {
      if (res.status === 'SUCCESS') {
        const dispatchObj = {
          checkingInternal: false,
          pincodeDataInternal: res.payload,
          checkedInternal: true,
          errorInternal: null,
          pincodeIndex: requestData.index
        };

        // checking if additional message present then it will show toastr for it.
        //(Zoom to Retry with ZRETL in case Compass returns 'No active contract found' on Check Pincode/Bulk Check Pincode)
        res.payload && res.payload.additionalMessage
          ? dispatch(
              checkPincodeServiceabilityInternalAction({
                ...dispatchObj,
                boomerang: {
                  component: 'toastr',
                  type: 'success',
                  removeExistingBms: true,
                  heading: 'Pincode Details',
                  message:
                    res.payload.additionalMessage ||
                    'Pincode detail fetched successfully after retrying with ZRETL.'
                }
              })
            )
          : dispatch(
              checkPincodeServiceabilityInternalAction({
                ...dispatchObj
              })
            );
      } else if (res.status === 'FAILURE') {
        dispatch(
          checkPincodeServiceabilityInternalAction({
            checkingInternal: false,
            pincodeDataInternal: null,
            checkedInternal: true,
            errorInternal: res.errorMessage || 'Pincode not serviceable',
            pincodeIndex: requestData.index
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('checkPincodeServiceabilityInternalAction call failed ', res);
      dispatch(
        checkPincodeServiceabilityInternalAction({
          checkingInternal: false,
          pincodeDataInternal: null,
          checkedInternal: true,
          errorInternal:
            res.errorMessage || 'Could not check pincode serviceability ',
          pincodeIndex: requestData.index
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log(
        'Exception in checkPincodeServiceabilityInternalAction call',
        res
      );
      dispatch(
        checkPincodeServiceabilityInternalAction({
          checkingInternal: false,
          pincodeDataInternal: null,
          checkedInternal: true,
          errorInternal: 'Could not check pincode serviceability ',
          pincodeIndex: requestData.index
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getFromToPairDetails = (requestData: Object) => (
  dispatch: Function
) => {
  dispatch(
    getFromToPairDetailsAction({
      fetchingFromToPairDetails: true,
      fromToPairDetails: null,
      fetchedFromToPairDetails: null,
      errorFromToPair: null
    })
  );

  const params = requestData.clientCode
    ? { clientCode: requestData.clientCode }
    : null;

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: requestData.isExternal
      ? 'pincodeFromToPairDetailsExternal'
      : 'pincodeFromToPairDetails',
    method: 'POST',
    pathVariables: [
      { key: '{from}', val: requestData.from },
      { key: '{to}', val: requestData.to }
    ],
    params,
    data: pincodeCallPostData(),
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getFromToPairDetailsAction({
            fetchingFromToPairDetails: false,
            fromToPairDetails: res.payload,
            fetchedFromToPairDetails: true,
            errorFromToPair: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getFromToPairDetailsAction({
            fetchingFromToPairDetails: false,
            fromToPairDetails: null,
            fetchedFromToPairDetails: true,
            errorFromToPair: res.errorMessage || 'Pincode not serviceable'
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getFromToPairDetailsAction call failed ', res);
      dispatch(
        getFromToPairDetailsAction({
          fetchingFromToPairDetails: false,
          fromToPairDetails: null,
          fetchedFromToPairDetails: true,
          errorFromToPair: res.errorMessage || 'Could not fetch pincode details'
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getFromToPairDetailsAction call', res);
      dispatch(
        getFromToPairDetailsAction({
          fetchingFromToPairDetails: false,
          fromToPairDetails: null,
          fetchedFromToPairDetails: true,
          errorFromToPair: 'Could not fetch pincode details'
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

// action fetch all the servicable pincodes (via client code and external user flag)
export const getAllServiceablePincodesViaClientCode = (
  clientCode,
  isExternal
) => (dispatch: Function) => {
  dispatch(
    getAllServiceablePincodesAction({
      downloading: true,
      downloaded: null,
      downloadError: null,
      downloadData: null,
      boomerang: {
        component: 'toastr',
        type: 'fetching',
        removeExistingBms: true,
        heading: 'Please wait',
        message: 'Downloading'
      }
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'pincodeDetailsViaClientCode',
    params: { clientCode: clientCode, isExternal: isExternal },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getAllServiceablePincodesAction({
            downloading: false,
            downloaded: true,
            downloadData: res.payload,
            downloadError: null
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getAllServiceablePincodesAction({
            downloading: false,
            downloaded: true,
            downloadData: [],
            downloadError: res.errorMessage || 'Could not download pincodes',
            boomerang: {
              component: 'toastr',
              type: 'error',
              removeExistingBms: true,
              heading: 'Error',
              message: res.errorMessage || 'Could not download pincodes'
            }
          })
        );
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('getAllServiceablePincodesAction call failed ', res);
      dispatch(
        getAllServiceablePincodesAction({
          downloading: false,
          downloaded: true,
          downloadData: [],
          downloadError: res.errorMessage || 'Could not download pincodes',
          boomerang: {
            component: 'toastr',
            type: 'error',
            removeExistingBms: true,
            heading: 'Error',
            message: res.errorMessage || 'Could not download pincodes'
          }
        })
      );
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception in getAllServiceablePincodesAction call', res);
      dispatch(
        getAllServiceablePincodesAction({
          downloading: false,
          downloaded: true,
          downloadData: [],
          downloadError:
            (res && res.errorMessage) || 'Could not download pincodes',
          boomerang: {
            component: 'toastr',
            type: 'error',
            removeExistingBms: true,
            heading: 'Error',
            message: (res && res.errorMessage) || 'Could not download pincodes'
          }
        })
      );
    }
  };

  return makeApiCall(requestObj);
};

export const getClients = (userProfile: Object) => (dispatch: Function) => {
  const defaultVal = {
    isLoading: false,
    isLoaded: true
  };
  dispatch(
    getClientsList({
      isLoading: true,
      isLoaded: false
    })
  );

  const apiEndPoint = checkIfClient(userProfile)
    ? 'getClientsById'
    : 'getCustomClients';
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: apiEndPoint,
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getClientsList({
            isLoading: false,
            isLoaded: true,
            clientList: res.payload || []
          })
        );
      } else {
        dispatch(getClientsList(defaultVal));
        toastr.error(
          'Something went wrong!',
          res.errorMessage || 'Failed to get clients'
        );
      }
    },
    failureCb: res => {
      dispatch(getClientsList(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Failed to get clients'
      );
    },
    catchCb: res => {
      dispatch(getClientsList(defaultVal));
      toastr.error('Something went wrong!', 'Failed to get clients');
    }
  };

  return makeApiCall(requestObj);
};
